import { http } from '@/utils/http.util';

export default class journeyService {
   async getJourneyById(id: Number) {
      return await http
         .get('/api/journey/' + id, {
            params: {
               include:
                  'customer.media,languages,journey_state,texts,steps.modules.module_type,steps.modules.choices,steps.modules.media,steps.modules.texts,steps.modules.sort_choices_by,steps.modules.property.texts,steps.texts,teams.tenant,referrals.team.tenant,referrals.referral_type,redirect_journey,referrals.journey_team',
            },
         })
         .then((response) => {
            return response.data;
         });
   }
}
